import CardBalance from './CardBalance';
import './CardBalance.css';

export default CardBalance;



// WEBPACK FOOTER //
// ./src/pages/Account/components/CardBalance/index.js